import http from '@/http'
import type { MediaThreeDModelSnapshotDto } from '@/interfaces/admin/threeDModel'

export async function getMediaByIdentifier (identifer: string) {
  const encoded = encodeURIComponent(identifer)
  const { data } = await http.get(`/medias/by-identifier/${encoded}`)
  return data
}

export async function getMediaById (id: number) {
  const { data } = await http.get(`/medias/${id}`)
  return data
}

export async function getMediaThreeDModelSnapshots (mediaId: number) {
  const limit = 1000
  let offset = 0
  let total: number | null = null
  const snapshots: MediaThreeDModelSnapshotDto[] = []

  do {
    const response = await http.get(`/medias/${mediaId}/3d-snapshots`, {
      params: {
        limit,
        offset,
        sort: 'threeDModelIdentifier:ASC,snapshotName:ASC'
      }
    })
    const page = Array.isArray(response.data) ? response.data : response.data?.items ?? []
    snapshots.push(...page)
    offset += page.length

    const headerTotal = Number(response.headers?.['x-total'])
    if (Number.isFinite(headerTotal)) total = headerTotal
    if (page.length < limit) break
  } while (total === null || offset < total)

  return snapshots
}
